'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "dropdownClassName", "disabled"];
import PropTypes from 'prop-types';
import I18n from 'I18n';
import styled from 'styled-components';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIFieldset from 'UIComponents/form/UIFieldset';
import UIImage from 'UIComponents/image/UIImage';
import StyleProtectedUIDropdown from '../style-protected/StyleProtectedUIDropdown';
import MarginInput from '../MarginInput';
import { toolbarI18nKey, textButtonStyles } from '../../constants/toolbar';
import { SpacingIconTypes } from '../../constants/spacing';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledProtectedImage = styled(UIImage).withConfig({
  displayName: "MarginControlButton__StyledProtectedImage",
  componentId: "z7k3c8-0"
})(["width:40px !important;height:40px !important;"]);
const renderMarginInput = (marginType, value, onChange) => {
  const handleChange = evt => {
    const {
      value: updatedValue
    } = evt.target;
    onChange({
      [marginType]: updatedValue
    });
  };
  return /*#__PURE__*/_jsx(MarginInput, {
    value: value,
    onChange: handleChange
  });
};
const renderMarginContent = props => {
  const {
    margin,
    marginIconType,
    onMarginChange,
    staticPrefix
  } = props;
  const handleMarginChange = updatedMargin => {
    onMarginChange(Object.assign({}, margin, updatedMargin));
  };
  return /*#__PURE__*/_jsxs(UIFieldset, {
    "data-test-id": "margin-control-content",
    className: "m-top-1 p-all-3",
    _size: "small",
    children: [/*#__PURE__*/_jsx(UIFlex, {
      direction: "row",
      justify: "center",
      children: renderMarginInput('top', margin.top, handleMarginChange)
    }), /*#__PURE__*/_jsxs(UIFlex, {
      direction: "row",
      align: "center",
      justify: "center",
      children: [renderMarginInput('left', margin.left, handleMarginChange), /*#__PURE__*/_jsx(StyledProtectedImage, {
        className: "m-all-2",
        responsive: false,
        width: 40,
        height: 40,
        src: `${staticPrefix}/images/${marginIconType}-icon.svg`
      }), renderMarginInput('right', margin.right, handleMarginChange)]
    }), /*#__PURE__*/_jsx(UIFlex, {
      className: "m-bottom-2",
      direction: "row",
      justify: "center",
      children: renderMarginInput('bottom', margin.bottom, handleMarginChange)
    })]
  });
};
const propTypes = {
  className: PropTypes.string,
  dropdownClassName: PropTypes.string,
  disabled: PropTypes.bool,
  margin: PropTypes.shape({
    top: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    left: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    right: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    bottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }).isRequired,
  marginIconType: PropTypes.oneOf(Object.values(SpacingIconTypes)),
  staticPrefix: PropTypes.string.isRequired,
  onMarginChange: PropTypes.func.isRequired
};
function MarginControlButton(props) {
  const {
      className,
      dropdownClassName,
      disabled
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(StyleProtectedUIDropdown, {
    "data-test-id": "margin-control-button",
    use: "unstyled",
    buttonText: I18n.text(toolbarI18nKey('margin')),
    buttonUse: "transparent",
    buttonClassName: className,
    autoPlacement: "horiz",
    placement: "bottom right",
    closeOnMenuClick: false,
    dropdownClassName: dropdownClassName,
    animateOnToggle: false,
    disabled: disabled,
    arrowSize: "medium",
    children: renderMarginContent(rest)
  });
}
MarginControlButton.propTypes = propTypes;
MarginControlButton.displayName = 'MarginControlButton';
const StyledMarginControlButton = styled(MarginControlButton).withConfig({
  displayName: "MarginControlButton__StyledMarginControlButton",
  componentId: "z7k3c8-1"
})(["", ""], textButtonStyles);
export default StyledMarginControlButton;